import {useField} from 'formik';
import classNames from 'classnames';
import styles from './form-textarea.module.scss';
import React, { CSSProperties } from 'react';

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label: string;
    name: string;
    placeholder?: string;
    stretch?: boolean;
    resize?: 'all' | 'vertical' | 'horizontal'
    multiple?: boolean;
    style?: CSSProperties;
}

const getResizeClass = (resize: 'all' | 'vertical' | 'horizontal'): string => {
    switch (resize) {
        case 'vertical':
            return styles.verticalResize;
        case 'horizontal':
            return styles.horizontalResize;
        default:
            return ''
    }
}

export const FormTextarea = (props: Props) => {
    const {
        className,
        label,
        required,
        resize = 'all',
        stretch = false,
        style,
        multiple,
        ...textareaProps
    } = props;
    void multiple;

    const [field, meta] = useField(textareaProps);
    const showError = Boolean(meta.error);
    const textareaClassName = classNames(
        styles.textarea,
        getResizeClass(resize),
        {
            [styles.errorState]: showError,
        },
        className
    );

    return (
        <label htmlFor={textareaProps.id || textareaProps.name} style={style} className={classNames({
            [styles.wrapper]: true,
            [styles.stretch]: stretch,
            [styles.auto]: !stretch
        })}>
            <div className={styles.labelRow}>
                <span className={styles.fieldName}>{label}</span>
                {required ? <span className={styles.asterisk}>*</span> : null}
                {required === false ? <span className={styles.optional}>(optional)</span> : null}
            </div>
            <textarea
                className={textareaClassName}
                aria-invalid={showError ? true : undefined}
                {...field}
                {...textareaProps} />
            {showError ? (<div className={styles.error}>{meta.error}</div>) : null}
        </label>
    );
}
